"use client";
import SideRailContent from "./renderSideRailContent";
import { SideRailComponentProps, ComponentListProps } from "../types";
import { extractComponentNames } from "@/utils/getSortedComponentsBySectionOrder";

interface Props {
  sideRailCollapsedHeaderComponents: SideRailComponentProps[] | undefined;
  sideRailCollapsedBodyComponents: SideRailComponentProps[] | undefined;
}

export default function CollapsedContent({
  componentList,
  sideRailCollapsedHeaderComponents,
  sideRailCollapsedBodyComponents,
}: Props & ComponentListProps) {
  const defaultSideRailCollapsedHeaderComponents: SideRailComponentProps[] = [
    { component: "sideRailTitle" },
    { component: "productTitle" },
    { component: "rating" },
  ];
  const headerComponents =
    sideRailCollapsedHeaderComponents ??
    defaultSideRailCollapsedHeaderComponents;

  const defaulSideRailCollapsedBodyComponents: SideRailComponentProps[] = [
    { component: "programCourses" },
    { component: "pricing" },
    { component: "ctaButton" },
  ];
  const bodyComponents =
    sideRailCollapsedBodyComponents ?? defaulSideRailCollapsedBodyComponents;

  return (
    <SideRailContent
      components={componentList}
      headerComponentsOrder={extractComponentNames(headerComponents)}
      bodyComponentsOrder={extractComponentNames(bodyComponents)}
    />
  );
}
